import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useFormik } from 'formik';
import ApprovalList from '../../components/approval/ApprovalList';

import ApprStatusChip from '../../components/common/datagrid/ApprStatusChip';

import { listApprovals } from '../../modules/approvalModule/approvals';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';
import * as yup from 'yup';
import dayjs from 'dayjs';
import ApprovalListBox from '../../components/approval/ApprovalListBox';
import ApprovalStatusList from '../../components/approval/ApprovalStatusList';

const ApprovalListContainer = () => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  // 홈 화면 위젯(결재 대기함/내 상신 진행)에서 ?searchType=/&searchStatus= 로 들어오면
  // 그 필터로 초기 조회한다 - 카드 숫자와 전체보기 목록 건수를 맞추기 위한 최소 딥링크 지원
  // (메인화면 역할별 구성 1단계, 2026-10-23). 최초 마운트 값만 읽고 이후 URL 변경은 추적하지 않는다
  // (ProjectListPage의 ?type= 패턴과 동일).
  const [searchParams] = useSearchParams();

  const [searchType, setSearchType] = useState(searchParams.get('searchType') || 'M');
  const [searchStatus, setSearchStatus] = useState(searchParams.get('searchStatus') || 'S');
  const [searchDocTyp, setSearchDocTyp] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('docCd');
  const [searchWords, setSearchWords] = useState(null);
  const [searchStrtDt, setSearchStrtDt] = useState('');
  const [searchEndDt, setSearchEndDt] = useState('');

  const { approvals, error, loading } = useSelector(
    ({ approvalModule, loading }) => ({
      approvals: approvalModule.approvals.approvals,
      error: approvalModule.approvals.error,
      loading: loading['approval/LIST_APPROVALS'],
    }),
  );

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'apprUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'docuUuid',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'docuCd',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'docuTyp',
        hide: true,
        type: 'string',
        editable: false,
        sortable: false,
        disableExport: true,
      },
      {
        field: 'docuNo',
        headerName: '문서번호',
        minWidth: 120,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'partnerInc',
        headerName: '고객명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'cstNm',
        headerName: '사업명',
        minWidth: 300,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'docuNow',
        headerName: '결재 단계',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => `${params.row.docuNow} / ${params.row.docuCnt}`,
      },

      {
        field: 'docuNow',
        headerName: '내 결재 단계',
        minWidth: 100,
        flex: 0.5,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'docuNowUsr',
        headerName: '현재 결재자',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
      },
      // {
      //   field: 'docuUsr',
      //   hide: true,
      //   type: 'string',
      //   editable: false,
      //   sortable: false,
      //   disableExport: true,
      // },
      // {
      //     field: 'docuUsrDptNm',
      //     headerName: '부서',
      //     minWidth: 200,
      //     flex: 1,
      //     type: 'string',
      //     editable: false,
      //     align: 'center',
      //     headerAlign: 'center',
      // },
      // {
      //     field: 'docuUsrNm',
      //     headerName: '이름',
      //     minWidth: 120,
      //     flex: 0.6,
      //     type: 'string',
      //     editable: false,
      //     align: 'center',
      //     headerAlign: 'center',
      // },
      // {
      //     field: 'docuUsrGradeNm',
      //     headerName: '직급',
      //     minWidth: 80,
      //     flex: 0.4,
      //     type: 'string',
      //     editable: false,
      //     align: 'center',
      //     headerAlign: 'center',
      // },
      {
        field: 'DOCU_STATUS',
        headerName: '결재여부',
        minWidth: 150,
        flex: 0.7,
        type: 'string',
        editable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: ApprStatusChip,
      },
      // {
      //     field: 'docuTxt',
      //     headerName: '기본사항',
      //     minWidth: 120,
      //     flex: 0.6,
      //     type: 'string',
      //     editable: false,
      //     align: 'center',
      //     headerAlign: 'center',
      // },
      {
        field: 'crtNm',
        headerName: '작성자',
        minWidth: 80,
        flex: 0.3,
        type: 'string',
        editable: false,
      },
      {
        field: 'crtDt',
        headerName: '작성일',
        minWidth: 150,
        flex: 0.8,
        type: 'string',
        editable: false,
      },
    ],
    [],
  );

  const handleRowClick = (param, event) => {
    navigate(`/approvalmng/${param.row.docuUuid}`);
  };

  const searchList = (values) => {
    const startDate =
      values.searchStrtDt !== null && values.searchStrtDt !== ''
        ? dayjs(values.searchStrtDt).format('YYYY-MM-DD')
        : '';
    const endDate =
      values.searchEndDt !== null && values.searchEndDt !== ''
        ? dayjs(values.searchEndDt).format('YYYY-MM-DD')
        : '';

    let searchData = {
      searchStatus: searchStatus,
      searchDocTyp: searchDocTyp,
      [values.searchKeyword]: values.searchWords,
      strtDt: startDate,
      endDt: endDate,
    };

    setSearchKeyword(values.searchKeyword);
    setSearchWords(values.searchWords);
    setSearchStrtDt(values.searchStrtDt);
    setSearchEndDt(values.searchEndDt);

    dispatch(listApprovals(searchType, searchData));
  };

  const initialValues = {
    searchKeyword: searchKeyword,
    searchWords: searchWords,
    searchStrtDt: searchStrtDt,
    searchEndDt: searchEndDt,
  };

  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
    searchStrtDt: yup.date().nullable().default(undefined),
    searchEndDt: yup
      .date()
      .min(yup.ref('searchStrtDt'), '검색 종료일을 확인하세요')
      .when('searchStrtDt', (searchStrtDt, schema) => {
        if (searchStrtDt) return schema.required('검색 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        searchList(values);
        setSubmitting(false);
      }, 1000);
    },
  });

  const onChangeStatus = (stats) => {
    if (stats === searchStatus) {
      stats = '';
    }
    setSearchStatus(stats);
  };

  const onChangeDocTyp = (type) => {
    if (type === searchDocTyp) {
      type = '';
    }
    setSearchDocTyp(type);
  };

  const onChangeTyp = (type) => {
    if (type === searchType) {
      type = 'M';
    }
    setSearchType(type);
  };

  // 컴포넌트 마운트 후 list 데이터 요청
  useEffect(() => {
    searchList(formik.values);
  }, [searchStatus, searchDocTyp, searchType]);

  return (
    <>
      <BreadcrumbsContainer title="결재관리/결재 리스트" />
      <ApprovalListBox formik={formik} />
      <ApprovalStatusList
        searchStatus={searchStatus}
        onChangeStatus={onChangeStatus}
        searchDocTyp={searchDocTyp}
        onChangeDocTyp={onChangeDocTyp}
        searchType={searchType}
        onChangeTyp={onChangeTyp}
      />
      <ApprovalList
        columns={columns}
        rows={approvals}
        loading={loading}
        handleRowClick={handleRowClick}
        columnVisibilityModel={{
          // Hide columns status and traderName, the other columns will remain visible
          id: false,
          apprUuid: false,
          docuUuid: false,
          docuCd: false,
          docuTyp: false,
        }} 
      />
    </>
  );
};

export default ApprovalListContainer;
